export const isAllowed = (allowedRoles, currentUserRoles) => {
  return currentUserRoles.some((currentUserRole) =>
    allowedRoles.includes(currentUserRole)
  );
};
